import { render, staticRenderFns } from "./appManagement.vue?vue&type=template&id=0733cade&scoped=true"
import script from "./appManagement.vue?vue&type=script&lang=js"
export * from "./appManagement.vue?vue&type=script&lang=js"
import style0 from "./appManagement.vue?vue&type=style&index=0&id=0733cade&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0733cade",
  null
  
)

export default component.exports